import { DynamicInput, FormLabel } from "shared";
import { ICommonTemplateComponentProps, ITemplateComponent } from "entities/template";
import React from "react";
import styles from "./label_field.module.scss";

interface ILabelFieldProps {
    component: ITemplateComponent;
    enLanguageEnabled: boolean;
    title: string;
    name: string;
    onChange: (value: Partial<ICommonTemplateComponentProps>) => void

}

export const LabelField: React.FC<ILabelFieldProps> = React.memo(({
                                                                      component,
                                                                      title,
                                                                      name,
                                                                      enLanguageEnabled,
                                                                      onChange
                                                                  }) => {
    const onFieldChange = (value: Partial<ICommonTemplateComponentProps>) => {
        onChange(value)
    }

    return <div className={styles.container}>
        <FormLabel title={title}>
            <DynamicInput size="m"
                          id="component_field_label"
                          value={component.label ? component.label : ""}
                          textareaEdge={70}
                          onChange={(e: any) => onFieldChange({ label: e.target.value })}
                          view="outline"
                          name={name}
            />
        </FormLabel>
        {enLanguageEnabled && <FormLabel title={`${title} [En]`}>
            <DynamicInput size="m"
                          id="component_field_label_en"
                          value={component.label_en ? component.label_en : ""}
                          textareaEdge={70}
                          onChange={(e: any) => onFieldChange({ label_en: e.target.value })}
                          view="outline"
                          name={`${name}-en`}
            />
        </FormLabel>}
    </div>

});
